import React, { useState, useEffect } from "react";
import axios from "../../axiosConfig";
import DeleteConfirmationModal from "../trainer/DeleteConfirmationModal";
import "../../styles/DogInfo.css";

const OwnerDogInfo = ({ dog, onUpdate }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [editedDog, setEditedDog] = useState({
        name: "",
        breed: "",
        dateOfBirth: "",
        gender: "",
        approximate: false,
    });

    // Initialize the edit state with the dog's current data
    useEffect(() => {
        if (dog) {
            setEditedDog({
                name: dog.name || "",
                breed: dog.breed || "",
                dateOfBirth: dog.dateOfBirth ? dog.dateOfBirth.substring(0, 10) : "",
                gender: dog.gender || "",
                approximate: dog.approximate || false,
            });
        }
    }, [dog]);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setEditedDog((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleEdit = () => {
        setIsEditing(true);
    };

    const handleCancel = () => {
        // Reset the form values from the original dog info
        setEditedDog({
            name: dog.name || "",
            breed: dog.breed || "",
            dateOfBirth: dog.dateOfBirth ? dog.dateOfBirth.substring(0, 10) : "",
            gender: dog.gender || "",
            approximate: dog.approximate || false,
        });
        setIsEditing(false);
    };

    const handleSave = async () => {
        const command = {
            dogId: dog.id,
            name: editedDog.name,
            breed: editedDog.breed,
            dateOfBirth: editedDog.dateOfBirth,
            approximate: editedDog.approximate,
            gender: editedDog.gender,
        };

        try {
            const response = await axios.put("/api/v1/dog/edit", command);
            if (onUpdate) {
                onUpdate(response.data);
            }
            setIsEditing(false);
        } catch (error) {
            console.error("Error updating dog info:", error);
        }
    };

    const handleDeleteClick = () => {
        setIsDeleteModalOpen(true);
    };

    const handleDeleteConfirm = async () => {
        try {
            await axios.delete(`/api/v1/dog/delete/${dog.id}`);
            setIsDeleteModalOpen(false);
            window.location.reload();
        } catch (error) {
            console.error("Error deleting dog:", error);
            setIsDeleteModalOpen(false);
        }
    };

    const handleDeleteCancel = () => {
        setIsDeleteModalOpen(false);
    };

    if (!dog) {
        return <p>Ładowanie danych zwierzęcia...</p>;
    }

    return (
        <div className="owner-dog-info-section">
            <DeleteConfirmationModal
                isOpen={isDeleteModalOpen}
                onClose={handleDeleteCancel}
                onConfirm={handleDeleteConfirm}
                itemName={dog.name}
            />
            <div className="owner-dog-info-header">
                <h3>Informacje o zwierzęciu</h3>
                <div className="owner-dog-actions in-header">
                    {isEditing ? (
                        <>
                            <button className="owner-zapisz-btn" onClick={handleSave}>
                                Zapisz
                            </button>
                            <button className="owner-edit-dog-btn" onClick={handleCancel}>
                                Anuluj
                            </button>
                        </>
                    ) : (
                        <>
                            <button className="owner-edit-dog-btn" onClick={handleEdit}>
                                Edytuj
                            </button>
                            <button className="owner-delete-dog-btn" onClick={handleDeleteClick}>
                                Usuń
                            </button>
                        </>
                    )}
                </div>
            </div>
            <div className="owner-dog-info">
                <div className="owner-info-group">
                    <label>Imię</label>
                    <input
                        type="text"
                        name="name"
                        value={editedDog.name}
                        onChange={handleInputChange}
                        disabled={!isEditing}
                    />
                </div>
                <div className="owner-info-group">
                    <label>Rasa</label>
                    <input
                        type="text"
                        name="breed"
                        value={editedDog.breed}
                        onChange={handleInputChange}
                        disabled={!isEditing}
                    />
                </div>
                {isEditing ? (
                    <div className="owner-info-group">
                        <label>Data urodzenia</label>
                        <input
                            type="date"
                            name="dateOfBirth"
                            value={editedDog.dateOfBirth}
                            onChange={handleInputChange}
                        />
                    </div>
                ) : (
                    <div className="owner-info-group">
                        <label>Wiek</label>
                        <input
                            type="text"
                            value={dog.age || ""}
                            disabled
                        />
                    </div>
                )}
                <div className="owner-info-group">
                    <label>Płeć</label>
                    <input
                        type="text"
                        name="gender"
                        value={editedDog.gender}
                        onChange={handleInputChange}
                        disabled={!isEditing}
                    />
                </div>
                {isEditing && (
                    <div className="owner-info-group checkbox-group">
                        <input
                            type="checkbox"
                            name="approximate"
                            checked={editedDog.approximate}
                            onChange={handleInputChange}
                        />
                        <label>Przybliżona data?</label>
                    </div>
                )}
            </div>
        </div>
    );
};

export default OwnerDogInfo;